import { useEffect, useState } from "react";
import ResultList from "./components/ResultList";
import "./App.css";
import { Value } from "./types";
import useApiCall from "./hooks/useApiCall";
import { API_URL_STRUCTURED_CONTENTS } from "./config";
import { formatURL } from "./utils";
import Filter from "./components/Filter";

function App() {
  const siteID = window.themeDisplay.getSiteGroupId();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(20);
  const [orderBy, setOrderBy] = useState<string>("");
  const [selectedTypes, setSelectedTypes] = useState<string[]>([]);

  const { data, loading } = useApiCall(
    formatURL(
      API_URL_STRUCTURED_CONTENTS + `${siteID}/structured-contents`,
      currentPage,
      itemsPerPage,
      orderBy,
      selectedTypes,
    )
  );

  useEffect(() => {
    setTotalPages(data?.lastPage || 1);
  }, [data]);

  return (
    <div className="psp-custom-search">
      <ResultList
        loading={loading}
        items={data?.items || []}
        totalResults={data?.totalCount}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
        setTotalPages={setTotalPages}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
      />
      <Filter
        setOrderBy={setOrderBy}
        selectedTypes={selectedTypes}
        setSelectedTypes={setSelectedTypes}
      />
    </div>
  );
}
export default App;
